import ReactRouterPrompt from 'react-router-prompt'
import { ALL_NS } from '~/i18n/namespaces'
import { useTranslation } from 'react-i18next'
import { BUTTON_TYPE } from '../popups/DialogFooter/Button.model'
import { IConfirmLeave } from './ConfirmLeave.model'
import { ConfirmationPopup } from '../popups/ConfirmationPopup'

export function ConfirmLeave({ isDirty, chilren, title }: IConfirmLeave) {
  const { t } = useTranslation(ALL_NS)
  return (
    <ReactRouterPrompt when={isDirty}>
      {({ isActive, onConfirm, onCancel }) =>
        isActive && (
          <ConfirmationPopup
            title={title ?? t('MessageTitle_LeaveScreen')}
            actionType='LeaveCancel'
            children={chilren ?? t('Message_ConfirmLeave')}
            onClose={action => {
              const isOk = action === BUTTON_TYPE.LEAVE
              if (isOk) {
                onConfirm()
              } else onCancel()
            }}
            open={true}
          />
        )
      }
    </ReactRouterPrompt>
  )
}
